const videos = {
  telegram: require("../assets/videos/telegram.mp4"),
};

export default videos;
